import { render, staticRenderFns } from "./EvidenceList.vue?vue&type=template&id=67fcc42a&"
import script from "./EvidenceList.vue?vue&type=script&lang=js&"
export * from "./EvidenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports